<aura-edit-wrapper
  [title]="sectionTitle()"
  [(isEditing)]="isEditing"
  [showDivider]="showDivider()"
  (saved)="profileSaved.emit($event!)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <div class="py-4">
      <etxe-agent-zone-activity-form
        [dto]="currentProfile()"
        [showMode]="showMode()"
        (validityChanged)="editWrapper.onValidityChanged($event)"
        (dtoChanged)="editWrapper.onDtoChanged($event)"
      />
    </div>
  } @else {
    <div class="pt-2">
      <etxe-agent-profile-display [profileData]="currentProfile()" [showMode]="showMode()" />
    </div>
  }
</aura-edit-wrapper>
